import React from 'react'

import { AcornsIcon } from '@acorns/icons'

import { VerificationContainer } from '../styled-components'

export const CheckingAccountApprovedScreen = () => {
  return (
    <VerificationContainer>
      <AcornsIcon icon={AcornsIcon.Icon.CheckmarkGreen} width="80px" />
    </VerificationContainer>
  )
}
